"use client";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
interface FaqItem {
  question: string;
  answer: string;
}
const faqs: FaqItem[] = [{
  question: "Do you deliver refrigerated trailers in Las Vegas?",
  answer: "Yes, we deliver to Las Vegas and the listed Southern Nevada communities. Delivery coverage is confirmed with each quote based on your location and trailer size."
}, {
  question: "Can I rent the 53-foot reefer trailer in Las Vegas?",
  answer: "The 53-foot reefer may be considered for temporary cold-storage needs in Las Vegas. Availability, temperature requirements, power or fuel needs, loading, delivery, site access, duration, and suitability are confirmed individually with each quote."
}, {
  question: "What power information should I provide for a Las Vegas rental?",
  answer: "Provide the available site power, if known. Power or fuel requirements vary by trailer and are confirmed individually with each quote. Requirements for the 53-foot reefer are confirmed separately."
}, {
  question: "Do you serve areas outside the listed Las Vegas communities?",
  answer: "Submit your delivery address with your quote request for individual review and coverage confirmation."
}, {
  question: "How is pricing determined?",
  answer: "Pricing is based on trailer size, rental dates, delivery location, site power availability, and optional add-ons. Your quote confirms final pricing."
}];
export default function LasVegasFaq() {
  return <section id="lasvegasfaq" data-nav="light" className="bg-background text-foreground py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-3xl font-semibold tracking-tight sm:text-4xl text-foreground">
            Las Vegas FAQ
          </h2>
        </div>

        <div className="bg-card text-card-foreground rounded-xl border border-border p-6 sm:p-8 shadow-xs">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => <AccordionItem key={index} value={`item-${index}`} data-index={index} className="border-b border-border py-2 last:border-b-0">
                <AccordionTrigger className="text-left font-medium text-base sm:text-lg text-foreground hover:no-underline hover:text-primary transition-colors py-4">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm sm:text-base leading-relaxed pt-1 pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}